export const company =
{
    name: 'A.K. Property',
    welcomeName: 'A.K. Property',
    mainServiceArea: 'Bangkok',
    navPhone: '+66 84 416 1459',
    phone1: '+66 84 416 1459',
    email: 'amrej.akproperty@gmail.com',
    address1: 'Bangkok',
    address2: 'Thailand',
    phoneUrl: 'tel:66844161459',
    // lineUrl: 'https://line.me/ti/p/jYMeqir21A',
    whatsappUrl: 'https://wa.me/66844161459',
    lineUrl: 'https://line.me/ti/p/qP-Uj1iEAC',
    // whatsappUrl: '',
    youtubeUrl: '',
    facebookUrl: 'https://www.facebook.com/profile.php?id=61553994074938',
    instagramUrl: '',
    tiktokUrl: '',
    linkedInUrl: ''
}
